export const SUCCESSFUL_ACCOUNT_PAYMENT  = "SUCCESSFUL_ACCOUNT_PAYMENT";
export const SUCCESSFUL_CC_URL_PAYMENT = "SUCCESSFUL_CC_URL_PAYMENT";
export const SUCCESSFUL_CONFIRM_PAYMENT_CREDIT_CARD  = "SUCCESSFUL_CONFIRM_PAYMENT_CREDIT_CARD";
export const SUCCESSFUL_TIGO_MONEY_PAYMENT = "SUCCESSFUL_TIGO_MONEY_PAYMENT";
export const SUCCESSFUL_MARK_SALEORDER_IN_PROGRESS = "SUCCESSFUL_MARK_SALEORDER_IN_PROGRESS";



// WEBPACK FOOTER //
// ./src/reducers/payment/actionConst.js